import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import ReactColorPicker from 'react-color-picker';
import { TextInputField } from 'common/components/form_fields';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);

    this.state = { showingPicker: false };
    this.togglePicker = this.togglePicker.bind(this);
  }

  togglePicker(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showingPicker: !this.state.showingPicker });
  }

  render() {
    const { value, onChange } = this.props;
    const isColorValid = /^#[0-9A-F]{6}$/i.test(value || '');

    return (
      <div className="color-picker">
        <div className="color-wrapper">
          { value && isColorValid &&
          <div className="color-preview" style={{ background: value }} /> }
          <button className="btn btn-text btn-with-icon btn-md" onClick={this.togglePicker}>
            <i className="fa fa-eyedropper" /> Pick Color
          </button>
        </div>
        {/* No `closeAction` is provided because we want to force the user to pick a valid color
            before leaving the modal. */}
        <ModalDialog modalOpen={this.state.showingPicker} modalHeader="Pick a color"
            dialogClasses="color-picker-modal" onPrimary={this.togglePicker} primaryLabel="Done"
            primaryDisabled={!isColorValid}>
          <ReactColorPicker value={value} onDrag={onChange} saturationWidth={200}
            saturationHeight={200} />
          <TextInputField meta={{}} label="HEX" input={{ value: value, name: 'hex', onChange }}/>
        </ModalDialog>
      </div>
    );
  }
}

ColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./common/components/color_picker.jsx